/* GLiTCH theme interactivity — vanilla JS, no framework */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const money = (cents) => '$' + (cents / 100).toFixed(2);

  /* ---------- Announcement rotation ---------- */
  (function () {
    const el = $('[data-announce-text]');
    const list = window.GLITCH_ANNOUNCEMENTS || [];
    if (!el || list.length < 2) return;
    let i = 0;
    setInterval(() => { i = (i + 1) % list.length; el.textContent = list[i]; }, 3500);
  })();

  /* ---------- Mobile menu ---------- */
  (function () {
    const menu = $('[data-mobile-menu]');
    if (!menu) return;
    $('[data-menu-open]') && $('[data-menu-open]').addEventListener('click', () => menu.classList.add('open'));
    $('[data-menu-close]') && $('[data-menu-close]').addEventListener('click', () => menu.classList.remove('open'));
    $$('[data-mobile-menu] a').forEach(a => a.addEventListener('click', () => menu.classList.remove('open')));
  })();

  /* ---------- Scroll reveal ---------- */
  (function () {
    const els = $$('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) { els.forEach(e => e.classList.add('in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1 });
    els.forEach(e => io.observe(e));
  })();

  /* ---------- FAQ / accordion ---------- */
  $$('[data-faq-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('[data-faq]');
      const open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  const backdrop = $('[data-cart-backdrop]');
  const openCart = () => { drawer && drawer.classList.add('open'); backdrop && backdrop.classList.add('open'); };
  const closeCart = () => { drawer && drawer.classList.remove('open'); backdrop && backdrop.classList.remove('open'); };
  $('[data-cart-open]') && $('[data-cart-open]').addEventListener('click', (e) => { e.preventDefault(); renderCart(); openCart(); });
  $('[data-cart-close]') && $('[data-cart-close]').addEventListener('click', closeCart);
  backdrop && backdrop.addEventListener('click', closeCart);

  async function getCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }
  function setCount(n) {
    const c = $('[data-cart-count]');
    if (!c) return;
    c.textContent = n;
    c.style.display = n > 0 ? 'flex' : 'none';
  }
  async function renderCart() {
    const body = $('[data-cart-body]');
    const foot = $('[data-cart-foot]');
    if (!body) return;
    const cart = await getCart();
    setCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<div style="text-align:center;padding:60px 20px;"><div style="font-size:64px;margin-bottom:16px;">🍬</div><div class="h-card mb-8">YOUR STASH IS EMPTY</div><div class="muted mb-24">Time to glitch the system.</div></div>';
      foot.innerHTML = '';
      return;
    }
    const free = cart.total_price >= 5000;
    const remain = Math.max(0, 5000 - cart.total_price);
    const pct = Math.min(100, (cart.total_price / 5000) * 100);
    body.innerHTML =
      '<div style="padding:4px 0 14px;">' +
        '<div style="font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:6px;">' +
          ((window.GLITCH_COUNTRY && window.GLITCH_COUNTRY !== 'US') ? 'Shipping calculated at checkout' : (free ? '✨ You unlocked free shipping!' : 'Spend ' + money(remain) + ' more for FREE shipping')) +
        '</div>' +
        '<div style="height:10px;background:var(--paper);border:2px solid var(--ink);border-radius:999px;overflow:hidden;"><div style="height:100%;width:' + pct + '%;background:var(--lime);"></div></div>' +
      '</div>' +
      cart.items.map(function (it) {
        return '<div class="cart-line">' +
          '<div class="cart-thumb">' + (it.image ? '<img src="' + it.image + '" alt="">' : '') + '</div>' +
          '<div><div style="font-weight:800;font-size:14px;line-height:1.2;margin-bottom:4px;">' + it.product_title + '</div>' +
          '<div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.05em;color:#666;margin-bottom:8px;">' + (it.variant_title || '') + (it.selling_plan_allocation ? ' · Subscription' : '') + '</div>' +
          (function(){ var p = it.properties || {}; var ks = Object.keys(p).filter(function(k){ return k && k.charAt(0) !== '_' && p[k]; }); if (!ks.length) return ''; return '<div style="font-size:11px;font-weight:600;color:#444;margin-bottom:8px;line-height:1.45;">' + ks.map(function(k){ return k + ': ' + p[k]; }).join('<br>') + '</div>'; })() +
          '<div class="qty-stepper"><button data-qty="' + it.key + '" data-dir="-1">−</button><span>' + it.quantity + '</span><button data-qty="' + it.key + '" data-dir="1">+</button></div></div>' +
          '<div style="text-align:right;"><div class="price">' + money(it.final_line_price) + '</div>' +
          '<button data-remove="' + it.key + '" style="font-size:11px;text-decoration:underline;margin-top:4px;opacity:0.7;">remove</button></div>' +
        '</div>';
      }).join('');
    const ship = free ? 0 : (cart.total_price > 0 ? 699 : 0);
    foot.innerHTML =
      '<div class="drawer-foot">' +
        '<div class="between" style="margin-bottom:8px;"><span style="font-weight:800;">Subtotal</span><span class="price">' + money(cart.total_price) + '</span></div>' +
        '<div class="between muted" style="margin-bottom:14px;font-size:13px;"><span>Shipping</span><span>' + ((window.GLITCH_COUNTRY && window.GLITCH_COUNTRY !== 'US') ? 'Calculated at checkout' : (ship === 0 ? 'FREE' : 'Calculated at checkout')) + '</span></div>' +
        '<a href="/checkout" class="btn btn-lime btn-lg" style="width:100%;justify-content:space-between;"><span>CHECKOUT</span><span>' + money(cart.total_price) + ' →</span></a>' +
      '</div>';
    foot.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () { /* handled below via body delegation */ });
    });
    body.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', async function () {
        const line = this.closest('.cart-line');
        const span = line.querySelector('.qty-stepper span');
        const newQty = parseInt(span.textContent, 10) + parseInt(this.dataset.dir, 10);
        await changeCart(this.dataset.qty, Math.max(0, newQty));
        renderCart();
      });
    });
    body.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', async function () { await changeCart(this.dataset.remove, 0); renderCart(); });
    });
  }
  async function changeCart(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }
  async function addToCart(id, sellingPlan) {
    const body = { items: [{ id: id, quantity: 1 }] };
    if (sellingPlan) body.items[0].selling_plan = sellingPlan;
    const r = await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    if (r.ok) { await renderCart(); openCart(); }
    else { const e = await r.json(); alert(e.description || 'Could not add to cart'); }
  }

  /* ---------- PDP image gallery (front/back thumbnails) ---------- */
  (function () {
    const gal = $('[data-pdp-gallery]');
    if (!gal) return;
    const imgs = $$('[data-gallery-img]', gal);
    const thumbs = $$('[data-gallery-thumb]', gal);
    const bursts = $$('[data-gallery-burst]', gal);
    const wiggle = $('.bag-wiggle', gal);
    if (thumbs.length < 2) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        const idx = parseInt(t.dataset.idx, 10);
        imgs.forEach(function (im) { im.style.display = (parseInt(im.dataset.idx, 10) === idx) ? 'block' : 'none'; });
        thumbs.forEach(function (tt) {
          const on = tt === t;
          tt.style.borderColor = on ? 'var(--ink)' : 'rgba(10,10,10,0.25)';
          tt.style.boxShadow = on ? '2px 2px 0 var(--ink)' : 'none';
        });
        // bursts + wiggle only on first (front) image
        bursts.forEach(function (b) { b.style.display = idx === 0 ? 'block' : 'none'; });
        if (wiggle) wiggle.style.animationPlayState = idx === 0 ? 'running' : 'paused';
      });
    });
  })();

  /* ---------- PDP ---------- */
  (function () {
    const pdp = $('[data-pdp]');
    if (!pdp) return;
    const jsonEl = $('[data-variant-json]');
    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}
    const form = $('[data-pdp-form]', pdp);
    const idInput = $('[data-variant-id]', pdp);
    const priceEl = $('[data-price]', pdp);
    const mobilePrice = $('[data-mobile-price]');
    const mobileSub = $('[data-mobile-sub]');
    const subToggle = $('[data-sub-toggle]', pdp);
    const subPlan = $('[data-sub-plan]', pdp);

    // current selection per option index
    const selected = [];
    $$('.pdp-optset', pdp).forEach(function (set, idx) {
      const sel = $('.pdp-opt.selected', set);
      selected[idx] = sel ? sel.dataset.optionValue : ($('.pdp-opt', set) ? $('.pdp-opt', set).dataset.optionValue : null);
      $$('.pdp-opt', set).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('.pdp-opt', set).forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          selected[idx] = btn.dataset.optionValue;
          updateVariant();
        });
      });
    });

    function matchVariant() {
      return variants.find(function (v) {
        return selected.every(function (val, i) {
          if (val == null) return true;
          return v.options[i] === val;
        });
      });
    }
    function updateVariant() {
      const v = matchVariant();
      if (!v) return;
      idInput.value = v.id;
      let price = v.price;
      if (subToggle && subToggle.checked) price = Math.round(price * 0.8);
      if (priceEl) priceEl.textContent = money(price);
      if (mobilePrice) mobilePrice.textContent = money(price);
      if (mobileSub) mobileSub.textContent = (v.title === 'Default Title' ? '' : v.title) + (subToggle && subToggle.checked ? ' · Subscribe' : '');
    }
    if (subToggle) {
      subToggle.addEventListener('change', function () {
        const wrap = $('[data-sub-wrap]', pdp);
        if (wrap) wrap.style.background = subToggle.checked ? 'var(--lime)' : 'var(--paper)';
        if (subPlan) subPlan.value = subToggle.checked ? subPlan.dataset.planId : '';
        updateVariant();
      });
    }
    updateVariant();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(idInput.value, subPlan && subPlan.value ? subPlan.value : null);
    });
    const mAdd = $('[data-mobile-add]');
    if (mAdd) mAdd.addEventListener('click', function () { addToCart(idInput.value, subPlan && subPlan.value ? subPlan.value : null); });

    // Sticky mobile ATC visibility
    const mainAtc = $('.pdp-main-atc', pdp);
    const mobileBar = $('[data-mobile-atc]');
    if (mainAtc && mobileBar) {
      const onScroll = function () {
        const r = mainAtc.getBoundingClientRect();
        mobileBar.classList.toggle('show', r.bottom < 0);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  })();

  /* ---------- Presale modal → Klaviyo "Presale Waitlist" ---------- */
  (function () {
    const backdrop = document.querySelector('[data-presale-backdrop]');
    if (!backdrop) return;
    const form = backdrop.querySelector('[data-presale-form]');
    const listId = form ? form.getAttribute('data-presale-list') : null;
    const COMPANY = 'V4i2gf';
    const open = function () { backdrop.style.display = 'flex'; };
    const close = function () { backdrop.style.display = 'none'; };
    document.querySelectorAll('[data-presale-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    backdrop.querySelector('[data-presale-close]') && backdrop.querySelector('[data-presale-close]').addEventListener('click', close);
    backdrop.addEventListener('click', function (e) { if (e.target === backdrop) close(); });
    if (form) form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const email = (form.querySelector('[data-presale-email]') || {}).value;
      const errEl = form.querySelector('[data-presale-error]');
      if (!email) return;
      try {
        const payload = { data: { type: 'subscription', attributes: {
          profile: { data: { type: 'profile', attributes: { email: email, properties: { source: 'presale-waitlist' } } } }
        }, relationships: { list: { data: { type: 'list', id: listId } } } } };
        const MASTER_LIST = 'TCLaiL';
        const subTo = function (lid) {
          const p = JSON.parse(JSON.stringify(payload));
          p.data.relationships.list.data.id = lid;
          return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(p)
          });
        };
        const results = await Promise.allSettled([subTo(listId), subTo(MASTER_LIST)]);
        const res = results[0].status === 'fulfilled' ? results[0].value : null;
        if (!res || (!res.ok && res.status !== 202)) throw new Error('klaviyo');
        form.querySelector('[data-presale-fields]').style.display = 'none';
        form.querySelector('[data-presale-success]').style.display = 'block';
      } catch (err) { if (errEl) errEl.style.display = 'block'; }
    });
  })();

  /* ---------- Ambassador form: Klaviyo list + event + email notification ---------- */
  (function () {
    const form = document.querySelector('[data-amb-form]');
    if (!form) return;
    const listId = form.getAttribute('data-amb-list');
    const COMPANY = 'V4i2gf';
    const val = function (sel) { const el = form.querySelector(sel); return el && el.value ? el.value.trim() : ''; };

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const email = val('[data-amb-email]');
      const name = val('[data-amb-name]');
      const handle = val('[data-amb-handle]');
      const followers = val('[data-amb-followers]');
      const why = val('[data-amb-why]');
      const errEl = form.querySelector('[data-amb-error]');
      const btn = form.querySelector('button[type="submit"]');
      if (!email) { if (errEl) errEl.style.display = 'block'; return; }
      if (errEl) errEl.style.display = 'none';
      if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; btn.innerHTML = 'SENDING...'; }

      const props = {
        social_handle: handle,
        follower_count: followers,
        why_glitch: why,
        applied_as: 'ambassador',
        ambassador_status: 'new',
        ambassador_applied_at: new Date().toISOString(),
        ambassador_source: window.location.pathname
      };

      const subscribe = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Ambassador form', profile: { data: { type: 'profile', attributes: { email: email, first_name: name, properties: props } } } }, relationships: { list: { data: { type: 'list', id: listId } } } } })
      });

      const track = fetch('https://a.klaviyo.com/client/events/?company_id=' + COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: { properties: props, metric: { data: { type: 'metric', attributes: { name: 'Ambassador Application' } } }, profile: { data: { type: 'profile', attributes: { email: email, first_name: name, properties: props } } } } } })
      });

      const body = new FormData();
      body.append('form_type', 'contact');
      body.append('utf8', '\u2713');
      body.append('contact[name]', name || 'Ambassador applicant');
      body.append('contact[email]', email);
      body.append('contact[body]', 'AMBASSADOR APPLICATION\n\nName: ' + name + '\nEmail: ' + email + '\nHandle: ' + handle + '\nFollowers: ' + (followers || 'not given') + '\nWhy GLiTCH: ' + (why || 'not given') + '\n\nAdded to the Klaviyo Ambassadors list.');
      const notify = fetch('/contact', { method: 'POST', body: body });

      try {
        const results = await Promise.allSettled([subscribe, track, notify]);
        const klaviyoOk = results[0].status === 'fulfilled' && (results[0].value.ok || results[0].value.status === 202);
        const notifyOk = results[2].status === 'fulfilled' && results[2].value.ok;
        if (!klaviyoOk && !notifyOk) throw new Error('both failed');
        form.querySelector('[data-amb-fields]').style.display = 'none';
        form.querySelector('[data-amb-success]').style.display = 'block';
      } catch (err) {
        if (errEl) errEl.style.display = 'block';
        if (btn) { btn.disabled = false; if (btn.dataset.label) btn.innerHTML = btn.dataset.label; }
      }
    });
  })();

  /* ---------- Drop countdown ---------- */
  (function () {
    const cd = document.querySelector('[data-countdown]');
    if (!cd) return;
    const target = new Date(cd.getAttribute('data-target')).getTime();
    const units = {
      days: cd.querySelector('[data-cd-unit="days"]'),
      hrs: cd.querySelector('[data-cd-unit="hrs"]'),
      min: cd.querySelector('[data-cd-unit="min"]'),
      sec: cd.querySelector('[data-cd-unit="sec"]')
    };
    const pad = function (n) { return String(n).padStart(2, '0'); };
    function tick() {
      const diff = Math.max(0, target - Date.now());
      if (units.days) units.days.textContent = pad(Math.floor(diff / 86400000));
      if (units.hrs) units.hrs.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (units.min) units.min.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (units.sec) units.sec.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* ---------- Build Your Own Box ---------- */
  (function () {
    const box = document.querySelector('[data-byob]');
    if (!box) return;
    // Mix-and-match bundle: pick bags across flavors; total must equal a real box size
    // (8/16/32). We add ONE bundle variant (qty 1) at the pack price, with the flavor
    // breakdown as line-item properties. No single-bag SKU is ever sold.
    const SIZES = [
      { n: 8,  id: box.getAttribute('data-box8'),  price: box.getAttribute('data-box8-price') },
      { n: 16, id: box.getAttribute('data-box16'), price: box.getAttribute('data-box16-price') },
      { n: 32, id: box.getAttribute('data-box32'), price: box.getAttribute('data-box32-price') }
    ];
    const MAX = 32;
    const addBtn = document.querySelector('[data-byob-add]');
    const totalEl = document.querySelector('[data-byob-total]');
    const noteEl = document.querySelector('[data-byob-note]');
    const barEl = document.querySelector('[data-byob-bar]');
    const mbar = document.querySelector('[data-byob-mbar]');
    const mCount = document.querySelector('[data-byob-mbar-count]');
    const mTarget = document.querySelector('[data-byob-mbar-target]');
    const mNote = document.querySelector('[data-byob-mbar-note]');
    const mSlots = document.querySelector('[data-byob-mbar-slots]');
    const mAdd = document.querySelector('[data-byob-mbar-add]');
    function total() { let t = 0; box.querySelectorAll('[data-byob-qty]').forEach(function (q) { t += parseInt(q.textContent, 10) || 0; }); return t; }
    function sizeFor(t) { for (var i = 0; i < SIZES.length; i++) { if (SIZES[i].n === t) return SIZES[i]; } return null; }
    function nextSize(t) { for (var i = 0; i < SIZES.length; i++) { if (t < SIZES[i].n) return SIZES[i].n; } return null; }
    function tierFor(t) { return t <= 8 ? 8 : (t <= 16 ? 16 : 32); }
    function renderSlots(t) {
      if (!mSlots) return;
      const tier = tierFor(t); let html = '';
      for (var i = 0; i < tier; i++) { html += (i < t) ? '<div class="byob-slot filled"></div>' : '<div class="byob-slot empty">+</div>'; }
      mSlots.innerHTML = html;
    }
    function refresh() {
      const t = total(); const size = sizeFor(t); const nxt = nextSize(t); const tier = tierFor(t);
      const ready = !!(size && size.id);
      const note = ready ? ("Perfect — that's a " + size.n + "-pack box.") : (nxt ? ('Add ' + (nxt - t) + ' more to reach a ' + nxt + '-pack box') : ('Max box is 32 bags — remove ' + (t - MAX) + '.'));
      totalEl.textContent = t;
      noteEl.textContent = note;
      barEl.style.width = Math.min(100, (t / 8) * 100) + '%';
      addBtn.disabled = !ready;
      addBtn.style.opacity = ready ? '1' : '0.5';
      addBtn.style.cursor = ready ? 'pointer' : 'not-allowed';
      addBtn.textContent = ready ? ('ADD ' + size.n + '-PACK BOX · ' + size.price) : 'KEEP STACKING';
      if (mCount) mCount.textContent = t;
      if (mTarget) mTarget.textContent = tier;
      if (mNote) mNote.textContent = note;
      renderSlots(t);
      if (mAdd) { mAdd.disabled = !ready; mAdd.style.opacity = ready ? '1' : '0.55'; mAdd.textContent = ready ? ('ADD ' + size.n + '-PACK · ' + size.price) : 'KEEP STACKING'; }
    }
    box.querySelectorAll('.byob-stepper').forEach(function (st) {
      const qEl = st.querySelector('[data-byob-qty]');
      st.querySelector('[data-byob-plus]').addEventListener('click', function () { if (total() >= MAX) return; qEl.textContent = (parseInt(qEl.textContent, 10) || 0) + 1; refresh(); });
      st.querySelector('[data-byob-minus]').addEventListener('click', function () { qEl.textContent = Math.max(0, (parseInt(qEl.textContent, 10) || 0) - 1); refresh(); });
    });
    async function doAdd() {
      let t = 0; const props = {};
      box.querySelectorAll('.byob-stepper').forEach(function (st) {
        const qty = parseInt(st.querySelector('[data-byob-qty]').textContent, 10) || 0;
        const flavor = st.getAttribute('data-flavor');
        if (qty > 0 && flavor) { props[flavor] = qty; t += qty; }
      });
      const size = sizeFor(t);
      if (!size || !size.id) return;
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: size.id, quantity: 1, properties: props }] }) });
      box.querySelectorAll('[data-byob-qty]').forEach(function (q) { q.textContent = '0'; });
      refresh();
      await renderCart(); openCart();
    }
    addBtn.addEventListener('click', doAdd);
    if (mAdd) mAdd.addEventListener('click', doAdd);
    if (mbar && 'IntersectionObserver' in window) {
      var mio = new IntersectionObserver(function (es) { es.forEach(function (e) { mbar.classList.toggle('show', e.isIntersecting); }); }, { threshold: 0 });
      mio.observe(box);
    }
    refresh();
  })();

  /* ---------- Flavor Quiz ---------- */
  (function () {
    const quiz = document.querySelector('[data-quiz]');
    if (!quiz) return;
    const stage = quiz.querySelector('[data-quiz-stage]');
    let data; try { data = JSON.parse(quiz.querySelector('[data-quiz-data]').textContent); } catch (e) { return; }
    let step = 0, picks = [];
    function dots() {
      return '<div class="row gap-8" style="margin-bottom:18px;justify-content:center;">' +
        data.questions.map(function (_, i) { return '<div style="width:36px;height:8px;border-radius:999px;background:' + (i <= step ? 'var(--hot-pink)' : 'rgba(10,10,10,0.15)') + ';"></div>'; }).join('') + '</div>';
    }
    function renderQ() {
      const q = data.questions[step];
      stage.innerHTML = dots() +
        '<div style="font-family:\'Bagel Fat One\',sans-serif;font-size:clamp(22px,3vw,30px);text-align:center;margin-bottom:24px;">' + q.q + '</div>' +
        '<div class="quiz-opts" style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">' +
        q.a.map(function (o, i) { return '<button type="button" class="quiz-opt" data-pick="' + o.f + '" style="padding:18px 16px;border:3px solid var(--ink);border-radius:14px;background:var(--paper);font-weight:800;font-size:15px;text-align:left;">' + o.t + '</button>'; }).join('') +
        '</div>';
      stage.querySelectorAll('[data-pick]').forEach(function (b) {
        b.addEventListener('click', function () { picks.push(b.getAttribute('data-pick')); if (step < data.questions.length - 1) { step++; renderQ(); } else { renderResult(); } });
      });
    }
    function winner() {
      const counts = {}; picks.forEach(function (f) { counts[f] = (counts[f] || 0) + 1; });
      const top = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0];
      return data.flavors[top];
    }
    function renderResult() {
      const w = winner();
      stage.innerHTML =
        '<div style="text-align:center;">' +
          '<div style="font-size:12px;font-weight:800;letter-spacing:0.08em;text-transform:uppercase;opacity:0.6;margin-bottom:8px;">Your flavor match is</div>' +
          '<div style="background:' + w.accent + ';border:3px solid var(--ink);border-radius:18px;padding:20px;display:inline-block;margin-bottom:20px;"><img src="' + w.img + '" alt="' + w.name + '" style="width:160px;height:160px;object-fit:contain;"></div>' +
          '<div style="font-family:\'Bagel Fat One\',sans-serif;font-size:clamp(30px,4vw,44px);line-height:1;">' + w.name + '</div>' +
          '<p class="body" style="margin:12px auto 0;max-width:420px;">' + w.taste + '</p>' +
          '<div class="row gap-12 wrap" style="justify-content:center;margin-top:24px;">' +
            '<a href="/products/' + w.handle + '" class="btn btn-lg btn-lime">SHOP ' + w.name.toUpperCase() + ' →</a>' +
            '<button type="button" data-quiz-retake class="btn btn-lg btn-cream">RETAKE</button>' +
          '</div>' +
        '</div>';
      stage.querySelector('[data-quiz-retake]').addEventListener('click', function () { step = 0; picks = []; renderQ(); });
    }
    renderQ();
  })();

  // initial cart count
  getCart().then(function (c) { setCount(c.item_count); }).catch(function () {});
})();
